import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setTradeInToggleVisibleState } from "../trade-in-your-car-wrapper/actions";
import TradeInAnotherCar from "./component";

const mapStateToProps = ({tradeIn: {
    tradeInToggleSelected
}}) => ({
    tradeInToggleSelected
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setTradeInToggleVisibleStateConnect: setTradeInToggleVisibleState
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TradeInAnotherCar);
